import React from "react";
import ConcessionalRates from "./components/concessional-rates/concessional-rates";
import EstablishedHomeRates from "./components/established-home-rates/established-home-rates";
import GeneralRates from "./components/general-rates/general-rates";
import ResidentialRates from "./components/residential-rates/residential-rates";
import VacantLandRates from "./components/vacant-land-rates/vacant-land-rates";
import appStyles from "../../app.module.css";

const TransferDuties = () => {
  return (
    <>
      <GeneralRates />
      <hr className={appStyles.rezziSeperator} />
      <ResidentialRates />
      <hr className={appStyles.rezziSeperator} />
      <ConcessionalRates />
      <hr className={appStyles.rezziSeperator} />
      <VacantLandRates />
      <hr className={appStyles.rezziSeperator} />
      <EstablishedHomeRates />
    </>
  );
};

export default TransferDuties;
